"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PromotionTallBannerWidgetDataSchema = exports.PromotionTallBannerItemSchema = exports.PromotionTallBannerWidgetLogSchema = void 0;
var zod_1 = require("zod");
exports.PromotionTallBannerWidgetLogSchema = zod_1.z.object({
    objectContainer: zod_1.z.string(),
    specialPriceNowId: zod_1.z.string(),
    widgetTargetTitle: zod_1.z.string(),
    widgetPosition: zod_1.z.number(),
});
exports.PromotionTallBannerItemSchema = zod_1.z.object({
    image: zod_1.z.object({
        url: zod_1.z.string(),
    }),
    action: zod_1.z.object({ app: zod_1.z.string(), web: zod_1.z.string() }),
    logMeta: zod_1.z.object({
        object: zod_1.z.string(),
        objectType: zod_1.z.string(),
        position: zod_1.z.number(),
        specialPriceNowItemTitle: zod_1.z.string(),
    }),
});
/**
 * [V1] 프로모션 배너 세로형 스와이프 - 응답 스키마 (YDM__NOL_PROMOTION_TALL_BANNER_SWIPE__V1)
 *
 * @see {@link https://yanolja.atlassian.net/wiki/spaces/CXT/pages/438076502/V1+YDM__NOL_PROMOTION_TALL_BANNER_SWIPE__V1+9.0.0~}
 */
exports.PromotionTallBannerWidgetDataSchema = zod_1.z.object({
    header: zod_1.z
        .object({
        icon: zod_1.z.string().optional(),
        title: zod_1.z.string(),
        subTitle: zod_1.z.string().optional(),
    })
        .optional(),
    items: zod_1.z.array(exports.PromotionTallBannerItemSchema),
    logMeta: exports.PromotionTallBannerWidgetLogSchema,
});
